exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".drag-drop-instructions {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.drag-drop-instructions h3 {\n  color: var(--active-color);\n}\n\n.drag-drop-instructions h4 {\n  color: var(--text-secondary-color);\n}\n", ""]);

